export async function fetchAuthToken(): Promise<string> {
  try {
    const res = await fetch('/api/auth/token', {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });

    // Tentar parsear o JSON, mas lidar com falhas de parseamento
    let json: any = {};
    try {
      json = await res.json();
    } catch (parseError) {
      console.error("[fetchAuthToken] Erro ao parsear JSON da resposta:", parseError);
      // Se não conseguiu parsear o JSON, ainda assim verificar res.ok para dar um erro mais específico
      if (!res.ok) {
        throw new Error(`Erro na rede ou no servidor (${res.status} ${res.statusText}).`);
      } else {
        // Se a resposta foi OK mas não é JSON válido, indica um problema no backend
        throw new Error("Resposta inválida do servidor: esperado JSON, mas recebeu outro formato.");
      }
    }

    if (!res.ok) {
      // Se a resposta não foi bem-sucedida (status 4xx, 5xx), lançar um erro com detalhes do backend
      const detail = json?.detail || json?.message || res.statusText || 'Erro desconhecido';
      throw new Error(`Falha na autenticação: ${detail} (Código: ${res.status}).`);
    }

    // Tentar obter o token de diferentes propriedades (token ou access_token)
    const token = json.token || json.access_token;

    if (typeof token !== 'string' || !token) { // Verificar se é string e não está vazia
      throw new Error("Token de acesso não fornecido ou inválido na resposta do backend.");
    }

    return token;
  } catch (err: any) {
    // Log do erro completo para depuração.
    console.error("[fetchAuthToken] Erro durante a obtenção do token:", err);
    // Relança o erro para que o componente chamador possa lidar com ele (ex: exibir um toast).
    throw err;
  }
}